import { backgroundOrange, blackOrange, darkOrange, gold, green, orange } from '@/theme/colors'
import styled from 'styled-components'

export const FormGroup = styled.div`
	margin-bottom: 1.25rem;

	&:last-child {
		margin-bottom: 0;
	}
`

export const FormLabel = styled.label`
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: #374151;
	margin-bottom: 8px;
`

export const FormInput = styled.input`
	width: 100%;
	padding: 12px 16px;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	font-size: 16px;
	transition:
		border-color 0.2s,
		box-shadow 0.2s;

	&:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}

	&::placeholder {
		color: #9ca3af;
	}
`

export const AmountInputWrapper = styled.div`
	position: relative;
	display: flex;
	align-items: center;
`

export const AmountPrefix = styled.span`
	position: absolute;
	left: 16px;
	font-size: 16px;
	color: #6b7280;
	pointer-events: none;
`

export const AmountInput = styled.input`
	width: 100%;
	padding: 12px 16px 12px 32px;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	font-size: 16px;
	transition:
		border-color 0.2s,
		box-shadow 0.2s;

	&:focus {
		outline: none;
		border-color: #3b82f6;
		box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
	}

	&::placeholder {
		color: #9ca3af;
	}

	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	-moz-appearance: textfield;
`

export const ButtonGroup = styled.div`
	display: flex;
	gap: 0.5rem;
	width: 100%;
	justify-content: flex-end;
`

export const Button = styled.button<{ $variant?: 'primary' | 'secondary' | 'ghost' }>`
	padding: 0.625rem 1.25rem;
	border-radius: 8px;
	font-size: 0.875rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s;
	border: 1px solid transparent;

	background: ${({ $variant }) => {
		if ($variant === 'primary') return green
		if ($variant === 'ghost') return 'transparent'
		return 'white'
	}};
	color: ${({ $variant }) => {
		if ($variant === 'primary') return 'white'
		if ($variant === 'ghost') return blackOrange
		return '#374151'
	}};
	border-color: ${({ $variant }) => {
		if ($variant === 'primary') return green
		if ($variant === 'ghost') return 'transparent'
		return '#d1d5db'
	}};

	&:hover:not(:disabled) {
		opacity: 0.9;
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`

export const StepIndicator = styled.div`
	font-size: 0.8125rem;
	font-weight: 500;
	color: ${gold};
	margin-bottom: 1.25rem;
	text-transform: uppercase;
	letter-spacing: 0.05em;
`

export const StepHeading = styled.h3`
	font-size: 1.0625rem;
	font-weight: 700;
	color: ${darkOrange};
	margin: 0 0 1.25rem 0;
`

export const BackButton = styled.button`
	background: transparent;
	border: none;
	color: ${blackOrange};
	font-size: 0.875rem;
	font-weight: 500;
	cursor: pointer;
	padding: 0;
	margin-bottom: 1rem;
	display: inline-flex;
	align-items: center;
	gap: 0.25rem;

	&:hover {
		text-decoration: underline;
	}
`

export const MemberList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
`

export const MemberRow = styled.button`
	display: flex;
	align-items: center;
	gap: 0.875rem;
	padding: 1rem 1.125rem;
	border-radius: 8px;
	background: white;
	border: 1px solid #e5e7eb;
	cursor: pointer;
	text-align: left;
	transition: all 0.15s;
	width: 100%;

	&:hover {
		border-color: ${orange};
		background: #fef9f6;
	}
`

export const ProfileAvatar = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background: ${orange};
	color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	font-size: 14px;
	flex-shrink: 0;
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`

export const MemberName = styled.span`
	font-size: 0.9375rem;
	font-weight: 500;
	color: #262626;
	flex: 1;
`

export const PayerRecipientRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.25rem;
	padding: 1.25rem;
	background: ${backgroundOrange};
	border-radius: 12px;
	margin-bottom: 1.5rem;
`

export const PayerRecipientPerson = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.5rem;
`

export const PayerRecipientLabel = styled.span`
	font-size: 0.75rem;
	color: #6b7280;
	text-transform: uppercase;
	letter-spacing: 0.05em;
`

export const PayerRecipientName = styled.span`
	font-size: 0.875rem;
	font-weight: 500;
	color: #262626;
`

export const PayerRecipientArrow = styled.div`
	color: ${darkOrange};
	font-size: 1.5rem;
	font-weight: 700;
`

export const HiddenInput = styled.input`
	display: none;
`

export const ImageSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`

export const ImagePreview = styled.div`
	width: 120px;
	height: 120px;
	border-radius: 8px;
	overflow: hidden;
	cursor: pointer;
	border: 1px solid #e5e7eb;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`

export const ImagePlaceholder = styled.label`
	width: 120px;
	height: 120px;
	border-radius: 8px;
	border: 2px dashed #d1d5db;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	color: #9ca3af;

	svg {
		width: 32px;
		height: 32px;
	}

	&:hover {
		border-color: ${orange};
		color: ${orange};
	}
`

export const ImageActions = styled.div`
	display: flex;
	gap: 0.5rem;
`

export const ImageActionButton = styled.button<{ $danger?: boolean }>`
	padding: 0.375rem 0.75rem;
	border-radius: 6px;
	font-size: 0.75rem;
	font-weight: 500;
	cursor: pointer;
	background: white;
	color: ${({ $danger }) => ($danger ? '#dc2626' : '#374151')};
	border: 1px solid ${({ $danger }) => ($danger ? '#fecaca' : '#d1d5db')};

	&:hover {
		background: ${({ $danger }) => ($danger ? '#fef2f2' : '#f9fafb')};
	}
`

export const ImageOverlay = styled.div`
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.85);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	cursor: pointer;

	img {
		max-width: 90%;
		max-height: 90%;
		object-fit: contain;
	}
`

export const ValidationError = styled.div`
	font-size: 0.8125rem;
	color: #dc2626;
	margin-top: 0.375rem;
`

export const SoftWarning = styled.div`
	font-size: 0.8125rem;
	color: ${gold};
	background: #fef3e2;
	padding: 0.5rem 0.75rem;
	border-radius: 6px;
	margin-top: 0.5rem;
`

export const ThirdPartyNotice = styled.div`
	font-size: 0.75rem;
	text-align: center;
	font-style: italic;
	margin-top: 1rem;
	line-height: 1.4;
`
